import DeleteOutlineIcon from "@mui/icons-material/DeleteOutlined"
import EditIcon from "@mui/icons-material/Edit"
import { Tooltip } from "@mui/material"
import type { BiomeshUnitRef } from "@phc/common/gen/threatAnalyticsGen"
import { branchTypeLabels, unitTypeLabels } from "../../Cop/copUtils"
import {
  ActionButton,
  CardHeader,
  CardRoot,
  CardTitle,
  Row,
  RowGroup,
} from "./shared"

export function UnitCard({
  unit,
  onEdit,
  onDelete,
}: {
  unit: BiomeshUnitRef
  onEdit?: () => void
  onDelete?: () => void
}) {
  return (
    <CardRoot>
      <CardHeader>
        <CardTitle variant="body2Bold">{unit.name}</CardTitle>
        {onEdit && (
          <Tooltip title="Edit unit">
            <ActionButton size="small" onClick={onEdit}>
              <EditIcon fontSize="small" />
            </ActionButton>
          </Tooltip>
        )}
        {onDelete && (
          <Tooltip title="Delete permanently">
            <ActionButton size="small" onClick={onDelete}>
              <DeleteOutlineIcon fontSize="small" />
            </ActionButton>
          </Tooltip>
        )}
      </CardHeader>
      <RowGroup>
        <Row label="Unit Type" value={unitTypeLabels[unit.unit_type]} />
        <Row label="Branch" value={branchTypeLabels[unit.branch_type]} />
        <Row label="UIC" value={unit.uic} />
      </RowGroup>
    </CardRoot>
  )
}
